module.exports = __webpack_public_path__ + "static/media/0002.470b95fc.JPG";